import { css } from '@emotion/react';
import { color, spacing, typography } from '@uniquegood/realworld-studio-design';

import ConnectCard from '../components/ConnectCard';

/**
 * Loading state — exchange API 호출 중.
 */
export default function LoadingState() {
  return (
    <ConnectCard eyebrow="Realworld School" title="스쿨 계정 연결">
      <div css={styles.container} data-testid="connect-state-loading">
        <div css={styles.spinner} aria-hidden="true" />
        <p css={styles.text}>연동 코드를 확인하고 있습니다.</p>
      </div>
    </ConnectCard>
  );
}

const spin = `
  @keyframes connect-spinner-rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

const styles = {
  container: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing.common.medium};
  `,
  spinner: css`
    ${spin};
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 3px solid ${color.border_default_subdued};
    border-top-color: ${color.interactive_primary_default};
    animation: connect-spinner-rotate 1s linear infinite;
  `,
  text: css`
    margin: 0;
    color: ${color.text_subdued};
    font-size: ${typography.size.s2};
    line-height: 1.5;
  `
};
